// Dev-only logging helpers. Silent in production builds so application
// internals are not exposed in the browser console.
const isDev = process.env.NODE_ENV !== 'production';

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const devDebug = (...args) => {
  if (isDev) console.debug(...args);
};
